import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/home";
import Products from "./pages/products";
import ProductPage from "./pages/productPage";
import WallPreview from "./pages/wallPreview";
import CartPage from "./pages/cart";
import WishList from "./pages/wishlist";
import Checkout from "./pages/checkout";
import ThankYou from "./pages/thankyou";
import Orders from "./pages/orders";
import Dashboard from "./pages/dashboard";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgotPassword";
import Signup from "./pages/signup";
import Account from "./pages/account";
import RecoverAccount from "./pages/recoverAccount";
import Navbar from "./components/navbar";
import WelcomeOffer from "./components/offer/WelcomeOffer";
import RouteLoader from "./components/PageLoader";
import Footer from "./components/footer";
import ProtectedRoute from "./components/protectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";

function App() {
  Modal.setAppElement("#root");

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    return null;
  };

  const Layout = ({ children }) => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
      <>
        {pathname === "/" && <WelcomeOffer />}
        {!isAdmin && <Navbar />}
        <main className={isAdmin ? "adminMain" : "pageMain"}>{children}</main>
        {!isAdmin && <Footer />}
      </>
    );
  };

  return (
    <div className="appContainer">
      <ScrollToTop />
      <RouteLoader />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        rtl
        pauseOnFocusLoss
        pauseOnHover
      />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/wall-preview" element={<WallPreview />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<WishList />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgotpass" element={<ForgotPassword />} />
          <Route path="/recoveracc" element={<RecoverAccount />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/account" element={<Account />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/orders" element={<Orders />} />
          </Route>

          <Route element={<ProtectedRoute isAdmin={true} />}>
            <Route path="/admin" element={<Dashboard />} />
          </Route>
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
